// SEARCH HEADERS
$(".icon-search").click(function () {
  $(".close-search").addClass("show");
  $(".modal_search").addClass("show_search");
  $(".icon-search").find("#form-search-icon").addClass("show");
});
$(".close-search").click(function () {
  $(".close-search").removeClass("show");
  $(".modal_search").removeClass("show_search");
  $("#form-search-icon").removeClass("show");
});
$(".modal_search").click(function () {
  $(".close-search").removeClass("show");
  $(".modal_search").removeClass("show_search");
  $(".icon-search").find("#form-search-icon").removeClass("show");
});


// ==================================================================
// MOBILE DRAWER NAVIGATION
//
// Both top-level toggles — Learn's (.wm-mobile-toggle) and Shop's
// (.drawer__nav-toggle--open) — are handled here directly. Shop's
// USED to be left to the theme's own ap-theme.js, but inspecting
// the live markup showed the toggle sits nested *inside* the <a>
// link, not next to it — ap-theme.js's `$(this).parent()` assumes
// the shallower structure, so it was silently failing to add the
// "active" class, and because it never calls preventDefault(), a
// tap on the arrow was also letting the click fall through to the
// link underneath it. Handling both here, the same way, with
// preventDefault/stopPropagation, fixes both at once and keeps
// them behaving identically.
//
// Second-level toggles inside a mega panel's own sub-lists are
// deliberately left to the theme's script — this only touches the
// top-level row.
//
// Tapping the LABEL itself (the page title text, not the arrow)
// still navigates to that page normally, like any other link.
//
// Listens on the document rather than on individual elements, so it
// keeps working after Shopify re-renders the header section in the
// theme editor.
// ==================================================================

(function () {
  // Point the chevron up when open, down when closed.
  function syncIcon(item, isOpen) {
    var icon = item.querySelector(
      ".drawer__nav-toggle--open i, .wm-mobile-toggle i"
    );
    if (!icon) return;
    icon.classList.toggle("fa-angle-down", !isOpen);
    icon.classList.toggle("fa-angle-up", isOpen);
  }

  function setExpanded(item, isOpen) {
    var toggle = item.querySelector(
      ".drawer__nav-toggle--open, .wm-mobile-toggle"
    );
    if (toggle) toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
  }

  function toggleItem(item) {
    var isOpen = item.classList.toggle("active");
    syncIcon(item, isOpen);
    setExpanded(item, isOpen);
  }

  document.addEventListener("click", function (e) {
    var toggle = e.target.closest(".wm-mobile-toggle, .drawer__nav-toggle--open");
    if (!toggle) return;

    // Only handle the top-level row's toggle here — a second-level
    // toggle further inside a mega panel's own sub-list is left to
    // the theme's own script.
    if (toggle.closest(".mega-col-inner")) return;

    var item = toggle.closest(".site-nav__item");
    if (!item) return;

    e.preventDefault();
    e.stopPropagation();

    toggleItem(item);
  });
})();

// ==================================================================
// SHOP MEGA MENU — SIDEBAR CATEGORY SWITCHER
//
// Clicking a category button (.wm-mega-shop__cat) shows the matching
// panel (.wm-mega-shop__panel with the same data-wm-panel index) and
// hides the rest. "Shop All" is already marked active in the Liquid
// markup, so this only needs to run on click — no setup on load.
//
// Delegated on the document (not bound per-button) so it keeps
// working after Shopify re-renders the header section in the theme
// editor, same as the handlers above.
// ==================================================================

document.addEventListener("click", function (e) {
  var btn = e.target.closest(".wm-mega-shop__cat");
  if (!btn) return;

  e.preventDefault();

  var wrapper = btn.closest(".wm-mega-shop");
  if (!wrapper) return;

  var targetIndex = btn.getAttribute("data-wm-cat");

  wrapper.querySelectorAll(".wm-mega-shop__cat").forEach(function (cat) {
    var isActive = cat === btn;
    cat.classList.toggle("active", isActive);
    cat.setAttribute("aria-selected", isActive ? "true" : "false");
  });

  wrapper.querySelectorAll(".wm-mega-shop__panel").forEach(function (panel) {
    panel.classList.toggle("active", panel.getAttribute("data-wm-panel") === targetIndex);
  });
});